import { h } from "preact";

/**
 * Pill-shaped radio group. Presentation only — callers own the selected value,
 * the copy and the change handler.
 *
 * @param {Object} param
 * @param {string} param.name - radio group name, must be unique per form
 * @param {string} param.legend - accessible label for the group
 * @param {{value: string, label: string, icon: ?string}[]} param.segments
 * @param {string} param.value - currently selected segment value
 * @param {Function} param.onChange - receives the change event
 */
export default function SegmentedToggle({
  name,
  legend,
  segments,
  value,
  onChange,
}) {
  return (
    <fieldset className="segmented-toggle">
      <legend className="visually-hidden">{legend}</legend>
      {segments.map((segment) => (
        <label key={segment.value} className="segmented-toggle__label">
          <input
            className="segmented-toggle__input"
            type="radio"
            name={name}
            value={segment.value}
            onChange={onChange}
            checked={value === segment.value}
          />
          <span className="segmented-toggle__label-text">
            {segment.icon && (
              <img
                className="segmented-toggle__icon"
                src={segment.icon}
                alt=""
                width="24"
                height="24"
                loading="lazy"
              />
            )}
            <span className="segmented-toggle__text">{segment.label}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
